var HeartbeatsViewModel = function () {
    var self = this;
    self.interval = ko.observable(60);
    self.grace = ko.observable(5);
    self.intervalFormatted = ko.pureComputed(function () {
        var intervalString = self.interval();
        if (!intervalString) return "";
        var interval = parseInt(intervalString);
        if (interval === 1) return "1 minute";
        if (interval === 60) return "1 hour";
        if (interval < 60) return interval + " minutes";
        if (interval >= 1440) return "1 day";
        return interval / 60 + " hours";
    });
    self.intervalAndGraceFormatted = ko.pureComputed(function () {
        var intervalString = self.interval();
        var graceString = self.grace();
        if (!intervalString || !graceString) return "";
        var interval = parseInt(intervalString);
        var grace = parseInt(graceString);
        var total = interval + grace;
        if (total < 60) return total + " minutes";
        var hours = Math.floor(total / 60);
        var remaining = total - (hours * 60);
        return (hours === 1 ? "1 hour" : hours + " hours") + (remaining > 0 ? " and " + (remaining === 1 ? "1 minute" : remaining + " minutes") : "");
    });

    const sliderInterval = document.querySelector('#slider-interval');
    noUiSlider.create(sliderInterval, {
        animate: false,
        start: self.interval(),
        connect: 'lower',
        range: { 'min': 1, '2%': 2, '4%': 3, '6%': 4, '8%': 5, '10%': 6, '12%': 7, '14%': 8, '16%': 9, '18%': 10, '20%': 11, '22%': 12, '24%': 13, '26%': 14, '28%': 15, '30%': 16, '32%': 17, '34%': 18, '36%': 19, '38%': 20, '40%': 21, '42%': 22, '44%': 23, '46%': 24, '48%': 25, '50%': 26, '52%': 27, '54%': 28, '56%': 29, '58%': 30, '62%': 60, '66%': 120, '70%': 180, '74%': 240, '78%': 300, '82%': 360, '91%': 720, 'max': 1440 },
        step: 1,
        snap: true,
        tooltips: true,
        format: {
            to: (val) => {
                if (val.toFixed() == 1) return "1 minute";
                if (val.toFixed() == 60) return "1 hour";
                if (val.toFixed() < 60) return val.toFixed() + " minutes";
                if (val.toFixed() >= 1440) return "1 day";
                return val.toFixed() / 60 + " hours";
            },
            from: (val) => val
        },
        pips: {
            mode: 'steps',
            density: 5
        }
    });

    sliderInterval.noUiSlider.on('update', function (values, handle) {
        if (values[handle].split(' ')[1] === "minute" || values[handle].split(' ')[1] === "minutes") {
            self.interval(parseInt(values[handle].split(' ')[0]));
        } else if (values[handle].split(' ')[1] === "hour" || values[handle].split(' ')[1] === "hours") {
            self.interval(parseInt(values[handle].split(' ')[0]) * 60);
        } else {
            self.interval(1440);
        }
    });

    const sliderGrace = document.querySelector('#slider-grace');
    noUiSlider.create(sliderGrace, {
        animate: false,
        start: self.grace(),
        connect: 'lower',
        range: {
            'min': 1,
            'max': 60
        },
        step: 1,
        tooltips: true,
        format: {
            to: (val) => {
                if (val.toFixed() == 1) return "1 minute";
                else if (val.toFixed() > 1 && val.toFixed() < 60) return val.toFixed() + " minutes";
                else if (val.toFixed() == 60) return "1 hour";
            },
            from: (val) => val
        },
        pips: {
            mode: 'steps',
            density: 5
        }
    });

    sliderGrace.noUiSlider.on('update', function (values, handle) {
        if (values[handle].split(' ')[1] !== "hour") {
            self.grace(parseInt(values[handle].split(' ')[0]));
        } else {
            self.grace(60);
        }
    });
};

document.addEventListener("DOMContentLoaded", function () {
    var vm = new HeartbeatsViewModel();
    ko.applyBindings(vm, document.body);
});
